/**
 * Payments Freshness Service
 *
 * When the payments visible to the signed-in contact last changed.
 */

import { investorPortalApiClient } from '../../shared/utils/api-client';

interface RawPaymentsLastUpdated {
  /** ISO timestamp, or null when the contact has no payments yet. */
  last_updated_at: string | null;
}

export class PaymentsLastUpdatedService {
  static async getLastUpdated(): Promise<string | null> {
    const response = await investorPortalApiClient.get<RawPaymentsLastUpdated>(
      '/portal/transactions/payments/last-updated'
    );

    return response.last_updated_at;
  }
}
